import { FeatureFlag } from 'modules/featureFlags/types';
import { PropsWithChildren, createContext, useContext } from 'react';

type FeatureContextState = {
  featureFlag: FeatureFlag;
};

export const defaultState: FeatureContextState = {
  featureFlag: {
    currentVersion: 0,
    feature: '',
    isFractional: false,
    settings: {
      disabledOrgIds: [],
      disabledProjectIds: [],
      enabledOrgIds: [],
      enabledProjectIds: [],
      enabledGlobally: false,
    },
  },
};

const FeatureContext = createContext<FeatureContextState>(defaultState);

export const useFeatureContext = () => useContext(FeatureContext);

export const FeatureContextProvider = ({
  featureFlag,
  children,
}: PropsWithChildren<FeatureContextState>) => (
  <FeatureContext.Provider value={{ featureFlag }}>{children}</FeatureContext.Provider>
);
